module.exports = __webpack_public_path__ + "img/17 de octubre_Apps con Inteligencia Artificial.57776b2f.png";